import i18n from '@/plugins/i18n';

export class DrawTooltip {
  // Val
  private readonly canvas: HTMLCanvasElement;
  private readonly ctx: CanvasRenderingContext2D;
  private readonly mode: string;
  private readonly height: number;

  private values: any = {
    propulsionPhase: {
      id: '',
      left: { abs: 0, rel: 0, ranges: { background: '', text: '', chevron: '' } },
      right: { abs: 0, rel: 0, ranges: { background: '', text: '', chevron: '' } },
    },
    strikePhase: {
      id: '',
      left: { abs: 0, rel: 0, ranges: { background: '', text: '', chevron: '' } },
      right: { abs: 0, rel: 0, ranges: { background: '', text: '', chevron: '' } },
    },
    propulsion: {
      left: 0,
      right: 0,
      leftStd: 0,
      rightStd: 0,
    },
    flatFoot: {
      left: 0,
      right: 0,
      leftStd: 0,
      rightStd: 0,
    },
    strike: {
      left: 0,
      right: 0,
      leftStd: 0,
      rightStd: 0,
    },
  };
  private readonly container: any = {
    sideLegend: {
      left: {
        startX: 0,
        endX: 0,
      },
      right: {
        startX: 0,
        endX: 0,
      },
    },
    chart: {
      height: 0,
      width: 0,
      paddingTop: 80,
      paddingBottom: 40,
      scale: {
        min: -30,
        max: 10,
        zones: [0, 10, 20, 30, 40, 50],
      },
    },
    middle: 0,
  };
  private readonly corridor: any = {
    propulsion: {
      min: 0,
      max: 0,
    },
    flatFoot: {
      min: 0,
      max: 0,
    },
    strike: {
      min: 0,
      max: 0,
    },
  };
  private tooltipsPos: any = {
    strike: {
      left: {
        x: 0,
        y: 0,
      },
      right: {
        x: 0,
        y: 0,
      },
    },
    flatFoot: {
      left: {
        x: 0,
        y: 0,
      },
      right: {
        x: 0,
        y: 0,
      },
    },
    propulsion: {
      left: {
        x: 0,
        y: 0,
      },
      right: {
        x: 0,
        y: 0,
      },
    },
  };
  private translations: any = {
    propulsion: i18n.t('commons.standards.propulsion') as string,
    flatFoot: i18n.t('commons.standards.flatfoot') as string,
    strike: i18n.t('commons.standards.strike') as string,
    left: i18n.t('commons.standards.left') as string,
    right: i18n.t('commons.standards.right') as string,
    corridor: i18n.t('commons.standards.corridor') as string,
    standardDeviation: i18n.t('commons.standards.standard-deviation') as string,
  };

  constructor(canvas: HTMLCanvasElement, container: any, values: any, corridor: any, tooltipsPos: any, mode: string) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d')!;
    this.mode = mode;
    this.height = this.canvas.height;

    this.container = container;
    this.values = values;
    this.corridor = corridor;
    this.tooltipsPos = tooltipsPos;
  }

  async drawTooltip() {
    this.clean();

    this.getTooltipZone();
    // this.getTooltipWindow();
  }

  getTooltipZone() {
    // Globals
    let tooltipZones: any = [];
    let i = 0;
    let zone;

    const height = 20;
    const width = this.container.middle - this.container.sideLegend.left.endX;
    const startX: any = {
      left: this.container.sideLegend.left.endX,
      right: this.container.middle,
    };
    this.ctx!.fillStyle = 'rgba(0,0,0,0)';

    for (const side of ['left', 'right']) {
      for (const type of ['propulsion', 'flatFoot', 'strike']) {
        /*this.ctx.beginPath();
        this.ctx.rect(startX[side], this.tooltipsPos[type][side].y - height / 2, width, height);
        this.ctx.fill();*/

        tooltipZones.push({
          side,
          type,
          x: startX[side],
          y: this.tooltipsPos[type][side].y - height / 2,
          w: width,
          h: height,
        });
      }
    }

    while ((zone = tooltipZones[i++])) {
      this.ctx.rect(zone.x, zone.y, zone.w, zone.h);
      this.ctx.fillStyle = 'rgba(0,0,0,0)';
      this.ctx.fill();
    }

    const that: any = this;
    this.canvas.onmousemove = function (e: any) {
      const rect = that.canvas.getBoundingClientRect();
      const x = e.clientX - rect.x;
      const y = e.clientY - rect.y;
      let i = 0;
      let zone = null;

      that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);

      while ((zone = tooltipZones[i++])) {
        that.ctx.beginPath();
        that.ctx.rect(zone.x, zone.y, zone.w, zone.h);
        that.ctx.fillStyle = 'rgba(0,0,0,0)';
        that.ctx.fill();
        that.ctx.fill();

        if (that.ctx.isPointInPath(x, y)) {
          that.getPointHover(zone.side, zone.type);
          that.getTooltipWindow(zone.side, zone.type);
        }
      }
    };
  }
  getTooltipWindow(side: string, type: string) {
    this.ctx!.shadowColor = 'rgba(255,0,0,0)';
    // Globals
    const height = 75;
    const width = 260;
    const padding = 15;
    const startX: any = {
      left: this.tooltipsPos[type][side].x + padding,
      right: this.tooltipsPos[type][side].x - padding - width,
    };
    const y = this.getYTooltipPosition(this.tooltipsPos[type][side].y, height);

    this.ctx!.shadowBlur = 10;
    this.ctx!.shadowOffsetX = 2;
    this.ctx!.shadowOffsetY = 2;

    this.ctx!.fillStyle = 'rgba(255,255,255,0.95)';
    this.ctx!.shadowColor = 'transparent';
    this.ctx!.shadowColor = 'rgba(52,52,52,0.2)';

    this.ctx.beginPath();
    this.ctx.rect(startX[side], y, width, height);
    this.ctx.fill();

    // Reset shadow
    this.ctx!.shadowColor = 'transparent';

    this.getTooltipWindowText(type, side, startX[side], y, width, height);
    this.getArrowIndicator(side, this.tooltipsPos[type][side].y, startX, width);
  }
  getArrowIndicator(side: string, yPointPos: number, windowX: any, windowWidth: number) {
    const height = 15;
    const width = 7;
    const isLeftSide = side === 'left';
    const posX: any = {
      left: windowX.left,
      right: windowX.right + windowWidth,
    };
    const arrowPoint = isLeftSide ? width * -1 : width;

    // Triangle - arrow indicator
    this.ctx!.beginPath();
    this.ctx!.moveTo(posX[side], yPointPos - height / 2);
    this.ctx!.lineTo(posX[side] + arrowPoint, yPointPos);
    this.ctx!.lineTo(posX[side], yPointPos + height / 2);
    this.ctx!.closePath();

    this.ctx!.fillStyle = 'rgba(255,255,255)';

    this.ctx.fill();
  }
  getPointHover(side: string, type: string) {
    this.ctx.fillStyle = 'rgba(103,108,124,0.25)';
    this.ctx.beginPath();
    this.ctx.arc(this.tooltipsPos[type][side].x, this.tooltipsPos[type][side].y, 15, 0, 2 * Math.PI);
    this.ctx.fill();
  }

  getTooltipWindowText(type: string, side: string, x: number, y: number, width: number, height: number) {
    // Globals
    const paddingX = 20;
    const paddingY = 28;
    const largePaddingY = 35;
    const pos = {
      min: {
        x: paddingX * 8.5,
        y: paddingY * 2,
      },
      max: {
        x: paddingX * 11,
        y: paddingY * 2,
      },
    };
    this.ctx!.fillStyle = '#717788';

    const stdValue: any = {
      left: this.values[type][side] + this.values[type].leftStd * (side === 'left' ? -1 : 1),
      right: this.values[type][side] + this.values[type].rightStd * (side === 'left' ? 1 : -1),
    };
    const angleText = `${this.translations[type]} (${this.translations[side]})`;
    const valueText = `${this.values[type][side].toFixed(1)}°`;

    this.ctx!.textAlign = 'left';
    this.ctx!.font = '600 24px Open Sans';
    this.ctx!.fillStyle = this.getAngleRange(this.values[type][side], type);
    this.ctx.fillText(valueText, x + paddingX, y + largePaddingY);
    this.ctx!.font = '500 13px Open Sans';
    this.ctx!.fillStyle = '#9BA0B0';
    this.ctx.fillText(angleText, x + paddingX, y + paddingY * 2);
    this.ctx!.textAlign = 'center';
    this.ctx.fillText('Min', x + pos.min.x, y + pos.min.y);
    this.ctx.fillText('Max', x + pos.max.x, y + pos.max.y);
    this.ctx!.font = '600 13px Open Sans';
    this.ctx!.fillStyle = this.getStdValueRange(stdValue.left, type).color;
    this.ctx.fillText(this.getStdValueRange(stdValue.left, type).text, x + pos.min.x, y + largePaddingY);
    this.ctx!.fillStyle = this.getStdValueRange(stdValue.right, type).color;
    this.ctx.fillText(this.getStdValueRange(stdValue.right, type).text, x + pos.max.x, y + largePaddingY);
  }

  getAngleRange(angle: number, type: string) {
    const range = this.corridor[type];
    switch (true) {
      case this.mode === 'rel':
        return '#717788';
      case angle < range.min:
      case angle > range.max:
        return '#ffae62';
      default:
        return '#2abf8f';
    }
  }
  getStdValue(name: string, side: string) {
    const val = this.values[name][side];
    return {
      min: (val - this.values[name][side + 'Std']).toFixed(1),
      max: (val + this.values[name][side + 'Std']).toFixed(1),
    };
  }
  getStdValueRange(angle: number, type: string) {
    const range = this.corridor[type];
    switch (true) {
      case this.mode === 'rel':
        return {
          color: '#717788',
          text: `${angle.toFixed(1)}°`,
        };
      case angle >= range.min && angle <= range.max:
        return {
          color: '#2abf8f',
          text: `${angle.toFixed(1)}°`,
        };
      case angle < range.min:
        return {
          color: '#ffae62',
          text: `⇩ ${angle.toFixed(1)}°`,
        };
      case angle > range.max:
        return {
          color: '#ffae62',
          text: `⇧ ${angle.toFixed(1)}°`,
        };
      default:
        return {
          color: '#2abf8f',
          text: `${angle.toFixed(1)}°`,
        };
    }
  }

  getYTooltipPosition(val: any, height: number) {
    const padding = 30;
    if (val - height / 2 < this.container.chart.paddingTop) return this.container.chart.paddingTop - padding;
    if (val + height / 2 > this.height - this.container.chart.paddingBottom)
      return this.height - this.container.chart.paddingBottom - height + padding;
    return val - height / 2;
  }

  clean() {
    // Store the current transformation matrix
    this.ctx!.save();

    // Use the identity matrix while clearing the canvas
    this.ctx!.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx!.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Restore the transform
    this.ctx!.restore();
    this.ctx!.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.ctx!.shadowColor = 'rgba(255,0,0,0)';
  }
}
